import { useQuery } from '@tanstack/react-query';

import HeatmapSurchargeService from '~/services/HeatmapSurchargeService';

import { heatmapSurchargeQueryKeys } from './heatmapSurchargeQueryKeys';

export function useGetHeatmapSurchargeCalendar(offerId?: string, roomTypeId?: string, checkInMonth?: string) {
  const filters = { roomTypeId, checkInMonth };

  return useQuery({
    queryKey: heatmapSurchargeQueryKeys.calendar(offerId ?? '', filters),
    queryFn: ({ signal }) => HeatmapSurchargeService.getCalendar(offerId, filters, { signal }),
    enabled: !!offerId,
    staleTime: 0,
    retry: false,
  });
}
